import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiEstimativaService } from 'src/app/modules/shared/services/api-estimativa.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { LanguageService } from 'src/app/modules/shared/services/language.service';

@Component({
  standalone: false,
  selector: 'app-ai-generate-dialog',
  templateUrl: './ai-generate-dialog.component.html',
  styleUrls: ['./ai-generate-dialog.component.css']
})
export class AiGenerateDialogComponent implements OnInit {

  variables: any;
  local_data: any;

  selectedFile: File | null = null;
  uploadedFilePath: string | null = null;
  isUploading: boolean = false;
  isGenerating: boolean = false;
  uploadError: string = '';
  generateError: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AiGenerateDialogComponent>,
    private estimativaService: ApiEstimativaService,
    private dataService: DataService,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];
    const maxSizeBytes = 10 * 1024 * 1024; // 10 MB

    if (file.size > maxSizeBytes) {
      this.uploadError = this.variables?.fileTooLarge || 'File exceeds the 10 MB limit.';
      return;
    }

    this.selectedFile = file;
    this.uploadedFilePath = null;
    this.uploadError = '';
    this.generateError = '';
    this.autoUpload();
  }

  private autoUpload(): void {
    if (!this.selectedFile) {
      return;
    }

    this.isUploading = true;
    this.uploadError = '';

    this.estimativaService.uploadFunctionalFile(this.selectedFile).subscribe({
      next: (result) => {
        this.uploadedFilePath = result.filePath;
        this.dataService.setLastAiFunctionalFilePath(result.filePath);
        this.isUploading = false;
      },
      error: (error) => {
        this.uploadError = this.resolveApiError(
          error,
          this.variables?.errorOnFileFormat || 'Error uploading the file. Please try again.'
        );
        this.isUploading = false;
        this.selectedFile = null;
        this.uploadedFilePath = null;
      }
    });
  }

  canGenerate(): boolean {
    return !!this.uploadedFilePath && !this.isUploading && !this.isGenerating;
  }

  generate(): void {
    if (!this.canGenerate()) {
      return;
    }

    this.isGenerating = true;
    this.generateError = '';

    const payload = {
      catalogId: this.local_data.catalogId,
      estimateId: this.local_data.estimateId,
      estimateName: this.local_data.estimateName,
      methodology: this.local_data.methodology,
      estimationModel: this.local_data.estimationModel || '',
      filePath: this.uploadedFilePath!
    };

    this.estimativaService.generateActivities(payload).subscribe({
      next: (result) => {
        this.isGenerating = false;
        this.dialogRef.close(result);
      },
      error: (error) => {
        this.generateError = this.resolveApiError(
          error,
          this.variables?.aiGenerateError || 'Erro ao gerar atividades. Por favor, tente novamente.'
        );
        this.isGenerating = false;
      }
    });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  private resolveApiError(error: any, fallback: string): string {
    return error?.error?.message || fallback;
  }
}
